import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'enumKeyValuelist'
})

export class EnumKeyValueListPipe implements PipeTransform {
    transform(value: any, args: any[]): any {
        const items: any[] = [];
        for (let key in value) {
            var isValueProperty = parseInt(key, 10) >= 0;
            if (!isValueProperty) continue;
            items.push({ key: key, value: value[key] });
        }
        return items;
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/pipes/enumKeyValueList.pipe.ts